export const schemaItems = $axios => ({
  get: ({ workflowStepId, schemaItemId }) => $axios.$get(
    `/workflow_steps/${workflowStepId}/schema_items/${schemaItemId}`,
  ),
});
